import React, { useEffect, useState, useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PrimaryButton, TextBox, SecondaryCheckbox, SingelSelect } from '../../../../../../Core/FormInput';
import { getByWorkflowIdAndStockID, processsReturnReasonForNewUSedStock } from '../../../../../../Core/Service/returnReason-service';
import MenuItem from '@material-ui/core/MenuItem';

const ReturnToWorkflow = (props) => {
    const [state, setState] = useState({
        loading: true,
        selectedReason: undefined,
        returnReasons: [],
        opNotes: '',
        technicianList: [],
        selectedTechnician: '',
        errors: {},
        nextWorkflowName: null
    });

    const [btnLoader, setBtnLoader] = useState(false);

    const handleClose = () => {
        props.onClose && props.onClose(false);
    };

    const setNotes = (e) => {
        const vl = e.target.value;
        setState((st) => ({ ...st, opNotes: vl }));
    };

    const singleSelectChange = (nm) => (ev, vl) => {
        let data = state.returnReasons.find((d) => d.returnReasonID === vl?.id);
        setState((st) => {
            let newSt = {
                ...st,
                [nm]: vl.id,
                nextWorkflowName: data?.nextWorkflowName,
                nextWorkflowID: data?.returnReasonNextWorkflowID
            };
            return newSt;
        });
    };

    const setTechnician = (e) => {
        const vl = e.target.value;
        setState((st) => ({ ...st, selectedTechnician: vl }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (state.technicianList?.length > 0 && !state.selectedTechnician) {
            formIsValid = false;
            errors['selectedTechnician'] = 'Please select technician';
        }

        if (!state.selectedReason) {
            formIsValid = false;
            errors['selectedReason'] = 'Please select return reason';
        }

        setState((st) => ({
            ...st,
            errors: errors
        }));
        return formIsValid;
    };

    const processReturn = async () => {
        if (handleValidation()) {
            setBtnLoader(true);
            const res = await processsReturnReasonForNewUSedStock(
                props.StockID,
                state.selectedReason,
                state.opNotes,
                state.selectedTechnician,
                state.resetSignature,
                false
            );
            props.showToast && props.showToast(res.message);
            if (res.success) {
                props.onReturnProcessed && props.onReturnProcessed(state.opNotes);
                props.onClose(true);

                window.location = `/UsedJob/${props.StockID}/${state.nextWorkflowID}?ProcessId=${props.ParamProcessId || ''}`;
            }
        }
    };

    useEffect(() => {
        getByWorkflowIdAndStockID(props.workflowId, props.StockID, false)
            .then((res) => {
                if (res.success) {
                    const ops = res.data.returnReasons.map((rr) => ({ id: rr.returnReasonID, name: rr.returnReasonDescription, ...rr }));
                    setState((st) => ({ ...st, returnReasons: ops }));
                } else {
                    props.showToast && props.showToast(res.message);
                }
            })
            .finally(() => {
                setState((st) => ({ ...st, loading: false }));
            });
    }, []);

    useEffect(() => {
        if (state.selectedReason) {
            const Technician = state.returnReasons?.filter((m) => m.id == state.selectedReason);
            let Tech = [];
            if (Technician[0]?.technicians != '') {
                Tech = JSON.parse(Technician[0]?.technicians);
            }
            setState((st) => ({ ...st, technicianList: Tech, selectedTechnician: '' }));
        }
    }, [state.selectedReason]);

    const handleCheck = (event) => {
        const { name, checked } = event.target;
        setState((st) => {
            const nst = { ...st, [name]: checked };
            return nst;
        });
    };

    return (
        <Dialog style={{ width: '100%' }} open={true} onClose={handleClose} fullWidth maxWidth="md" className="dialog-custom">
            <DialogTitle>
                Return Reason
                <div className="title-header-actions">
                    <span className="close-icon" onClick={handleClose}>
                        &times;
                    </span>
                </div>
            </DialogTitle>
            <DialogContent>
                <label>Return Reason:</label>
                <br />

                <SingelSelect
                    disableClearable
                    onChange={singleSelectChange('selectedReason')}
                    options={state.returnReasons || []}
                    value={state.selectedReason}
                />
                <span className="mandatoryfields">{state.errors['selectedReason']}</span>

                {/* <TextBox select name="selectedReason" value={state.selectedReason} variant="outlined" onChange={setReturnReason} autoFocus={true}>
                    {state.returnReasons?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextBox> */}
                {state.technicianList?.length > 0 && (
                    <>
                        <label>Technician:</label>
                        <br />
                        <TextBox select name="selectedTechnician" value={state.selectedTechnician} variant="outlined" onChange={setTechnician} autoFocus={true}>
                            {state.technicianList?.map((option) => (
                                <MenuItem key={option.StockID} value={option.StockID}>
                                    {option.Technician}
                                </MenuItem>
                            ))}
                        </TextBox>
                        <span className="mandatoryfields">{state.errors['selectedTechnician']}</span>
                        <FormControlLabel
                            control={
                                <SecondaryCheckbox checked={state.resetSignature} onChange={handleCheck} name="resetSignature" value={state.resetSignature} />
                            }
                            label="Reset Signature"
                        />
                    </>
                )}
                <TextBox rows={5} multiline label="New Note" required={false} onChange={setNotes} value={state.opNotes} />
                {state.nextWorkflowName && <label>Return Job to : {state.nextWorkflowName} </label>}
                <br />
                <PrimaryButton fullWidth isBtnLoader={btnLoader} onClick={processReturn}>
                    Submit
                </PrimaryButton>
            </DialogContent>
        </Dialog>
    );
};

export default ReturnToWorkflow;
